import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { DateInputSize } from '@progress/kendo-angular-dateinputs';
import { CheckBoxRounded } from '@progress/kendo-angular-inputs';
import { DictionaryContractType } from 'src/app/extensions/constants/dictionaryConstants/dictionaryConstants';
import { ContractAPIService } from 'src/app/extensions/services/api/contracts-api.service';
import { isEqual } from 'lodash';

@Component({
  selector: 'invoice-list-contract',
  templateUrl: './invoice-list-contract.component.html',
  styleUrls: ['./invoice-list-contract.component.scss'],
  standalone: false,
})
export class InvoiceListContractComponent implements OnInit {
  public constructor(
    private _activeModal: NgbActiveModal,
    private _contractAPIService: ContractAPIService,
    private _translateService: TranslateService
  ) {}

  public roundedLarge: CheckBoxRounded = 'large';
  public size: DateInputSize = 'large';

  public pageFilter: app.models.GetPagedInvoicesPageFilterModel;
  contractTypes: app.models.DictionaryWithCheckbox[];

  public contracts: app.models.ActiveContractModel[];
  public activeContracts: app.models.ActiveContractModel[] = [];
  public inactiveContracts: app.models.ActiveContractModel[] = [];
  initialFilterState: app.models.GetPagedInvoicesPageFilterModel;
  public withoutContract: boolean;

  public ngOnInit(): void {
    this.getContracts();
  }

  getContracts() {
    this._contractAPIService.getActiveContracts().subscribe(activeContracts => {
      this.activeContracts = activeContracts;
      this.activeContracts.forEach(x => (x.isSelected = this.pageFilter.contracts.includes(x.contractId)));
      this.contracts = this.activeContracts;
      if (this.pageFilter.isInactiveContractsSelected) {
        this.inactiveHandler();
      }

      this.contractTypes = [
        {
          name: this._translateService.instant('contracts.contractType.operationalLeasing'),
          isSelected: this.pageFilter.contractTypeCodes.includes(DictionaryContractType.OPERATIONAL_LEASING),
          value: DictionaryContractType.OPERATIONAL_LEASING,
        },
        {
          name: this._translateService.instant('contracts.contractType.financialLeasing'),
          isSelected: this.pageFilter.contractTypeCodes.includes(DictionaryContractType.FINANCIAL_LEASING),
          value: DictionaryContractType.FINANCIAL_LEASING,
        },
        {
          name: this._translateService.instant('contracts.contractType.credit'),
          isSelected: this.pageFilter.contractTypeCodes.includes(DictionaryContractType.CREDIT),
          value: DictionaryContractType.CREDIT,
        },
      ];
      this.withoutContract = this.pageFilter.withoutContract;
    });
  }

  public closeHandler() {
    this._activeModal.close(false);
  }

  public resetHandler() {
    this.pageFilter.contracts = [];
    this.pageFilter.contractTypeCodes = [];
    this.pageFilter.withoutContract = false;
    this.pageFilter.isInactiveContractsSelected = false;
    this._activeModal.close(isEqual(this.pageFilter, this.initialFilterState) ? false : 0);
  }

  public applyHandler() {
    this.pageFilter.contracts = this.contracts.filter(x => x.isSelected).map(x => x.contractId);
    this.pageFilter.contractTypeCodes = this.contractTypes.filter(x => x.isSelected).map(x => x.value);
    this.pageFilter.isInactiveContractsSelected = this.inactiveContracts.filter(x => x.isSelected).length > 0;
    this.pageFilter.withoutContract = this.withoutContract;

    this._activeModal.close(
      isEqual(this.pageFilter, this.initialFilterState)
        ? false
        : this.pageFilter.contractTypeCodes.length +
            this.pageFilter.contracts.length +
            (this.pageFilter.withoutContract ? 1 : 0)
    );
  }

  public contractHandler(contractId: string) {
    const contract = this.contracts.find(x => x.contractId == contractId);
    if (contract) {
      contract.isSelected = !contract.isSelected;
    }
  }

  public inactiveHandler() {
    this._contractAPIService.getInactiveContracts().subscribe(x => {
      this.inactiveContracts = x;
      this.inactiveContracts.forEach(x => (x.isSelected = this.pageFilter.contracts.includes(x.contractId)));
      this.contracts = [...this.contracts, ...this.inactiveContracts];
    });
  }
}
